import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[tcPanelItemHost]',
})
export class TcPanelItemDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
